"use client";
import React from "react";
import areaList from "@/data/area";

type Props = {
  categoryName: string;
  categorySlug: string;
};

const Coverage = ({ categoryName, categorySlug }: Props) => {
  return (
    <section id="coverage" className="scroll-mt-30">
      <div className="py-20 text-center bg-[#f9fafb]">
        <div className="max-w-[1170px] w-full mx-auto px-4 sm:px-8 xl:px-0">
          <h2 className="text-lg font-semibold mb-4 text-gray-700">
            Dimana Bisa Sewa {categoryName}? Berikut Daftar Kota Layanannya
          </h2>
          <div className="flex flex-wrap justify-center gap-3">
            {areaList.map((kota) => {
              const slug = `${categorySlug}-${kota.slug}`;
              return (
                <a
                  key={slug}
                  href={`/${slug}`}
                  title={`Sewa ${categoryName} di ${kota.name}`}
                  className="inline-block px-4 py-2 rounded-full bg-purple-100 text-purple-700 text-sm hover:bg-purple-200 transition"
                >
                  {kota.name}
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Coverage;
